import { Box, Divider, Stack, Typography, alpha } from '@mui/material';
import { PredictionsAndMetadataImageContent } from './PredictionsAndMetadataImage';

export const AllFeedbackContentsImage = () => {
  return (
    <Box
      width={250}
      borderRadius={1}
      bgcolor={(theme) => alpha(theme.palette.text.primary, 0.1)}
    >
      <Stack spacing={0.6} padding={1}>
        <Stack spacing={0.6}>
          <Typography fontSize="8px">Feedback & Summary</Typography>
          <Box
            bgcolor={(theme) => alpha(theme.palette.background.paper, 0.8)}
            borderRadius={1}
          >
            <Stack spacing={0.8} px={1} py={1.5} sx={{ opacity: 0.7 }}>
              <Box
                width="100%"
                height={2}
                borderRadius={4}
                bgcolor="primary.main"
              />
              <Box
                width="100%"
                height={2}
                borderRadius={4}
                bgcolor="primary.main"
              />
              <Box
                width="100%"
                height={2}
                borderRadius={4}
                bgcolor="primary.main"
              />
            </Stack>
          </Box>
        </Stack>
        <Divider sx={{ opacity: 0.2, mt: 1, mb: 0.5 }} />
        <Stack spacing={0.6}>
          <PredictionsAndMetadataImageContent />
        </Stack>
      </Stack>
    </Box>
  );
};
